import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { InventoryDiffPage, parseDiffSearch, type DiffSearchParams } from "@/features/reports";

function DiffRoute(): JSX.Element {
  const navigate = Route.useNavigate();
  const { highlight, overOnly } = Route.useSearch();
  const onOverOnlyChange = (next: boolean): void =>
    void navigate({ search: (prev) => ({ ...prev, overOnly: next }) });
  return highlight ? (
    <InventoryDiffPage
      highlight={highlight}
      overOnly={overOnly}
      onOverOnlyChange={onOverOnlyChange}
    />
  ) : (
    <InventoryDiffPage overOnly={overOnly} onOverOnlyChange={onOverOnlyChange} />
  );
}

export const Route = createFileRoute("/_authenticated/inventory-diff")({
  validateSearch: (search): DiffSearchParams => parseDiffSearch(search as Record<string, unknown>),
  component: DiffRoute,
});
